import * as React from 'react'
import { PropsWithChildren, ReactElement } from 'react'
import { Card as FluentCard, CardProps, mergeClasses } from '@fluentui/react-components'
import useViewport, { Viewport } from '../hooks/useViewport'
import { getTheme, mergeStyleSets } from '@fluentui/react'

const theme = getTheme()
const styles = mergeStyleSets({
    card: {
        marginLeft: theme.spacing.s1,
        marginRight: theme.spacing.s1,
    },
})

export default function Card(props: PropsWithChildren<CardProps>): ReactElement {
    const { isViewport } = useViewport()
    return (
        <FluentCard
            size={isViewport('<', Viewport.Large) ? 'small' : 'medium'}
            {...props}
            className={mergeClasses(styles.card, props.className)}
        >
            {props.children}
        </FluentCard>
    )
}
